<bn-loading-overlay></bn-loading-overlay>
<div class="container"  *ngIf="model">
    <form [formGroup]="formJanelaAtualizacaoInfo" class="form">

        <div class="row">
            <div class="col">
                <h3>Janela de atualização de informações <small *ngIf="model.id" class="text-muted">(#ID: {{model.id}})</small></h3>
            </div>

            <div class="col-auto">
                <button type="button" class="btn " 
                  [ngClass]="formJanelaAtualizacaoInfo.pristine ? 'btn-primary' : 'btn-danger' " 
                  (click)="voltarOuCancelar()"> {{ modoEdicao ? "Cancelar" : "Voltar"}}
                </button>
                
                <button *ngIf="podeEditar && !modoEdicao" type="button" class="btn btn-primary" 
                  (click)="editar()">Editar
                </button>

                <button *ngIf="podeEditar && !modoEdicao && podeHabilitarProcessamento && !formJanelaAtualizacaoInfo.get('processamentoHabilitado').value" type="button" class="btn btn-primary" 
                  (click)="habilitarProcessamento()">Habilitar Processamento
                </button>

                <button *ngIf="podeEditar && !modoEdicao && formJanelaAtualizacaoInfo.get('processamentoHabilitado').value" type="button" class="btn btn-primary" 
                [disabled]="formJanelaAtualizacaoInfo.get('ultimaExecucaoRealizadaComSucesso').value"
                (click)="desabilitarProcessamento()">Desabilitar Processamento
              </button>

                <button *ngIf="modoEdicao" type="button" class="btn btn-primary" 
                  [disabled]="formJanelaAtualizacaoInfo.pristine || !formJanelaAtualizacaoInfo.valid" 
                  (click)="salvar ()">Salvar
                </button>
            </div>
        </div>

        <div class="row">

            <div class="bn-form-group col-md-6">
                <label class="form-label"><b>Tipo de Janela:</b></label>
                <select id="tipoJanela" class="form-select" formControlName="tipoJanela">
                    <option *ngFor="let tipoJanela of tiposJanela" 
                            [ngValue]="tipoJanela.codigo">{{ tipoJanela.label }}</option>
                </select>
            </div>

            <div class="bn-form-group col-md-6">
                <label class="form-label"><b>Data Base</b></label>
                <bn-datepicker idInput="dataBase" formControlName="dataBase" ></bn-datepicker>
            </div>

            <div class="bn-form-group col-md-6">
                <label class="form-label"><b>Data de Abertura</b></label>
                <bn-datepicker idInput="dataAbertura" formControlName="dataAbertura" ></bn-datepicker>
            </div>
    
            <div class="bn-form-group col-md-6">
                <label class="form-label"><b>Data de Fechamento</b></label>
                <bn-datepicker idInput="dataFechamento" formControlName="dataFechamento" ></bn-datepicker>
            </div>

            <div class="bn-form-group col-md-6">
                <label class="form-label"><b>Data de Início de Listagem de Operações</b></label>
                <bn-datepicker idInput="dataInicioListagemOperacoes" formControlName="dataInicioListagemOperacoes" ></bn-datepicker>
            </div>

            <div class="bn-form-group col-md-6">
                <label class="form-label"><b>Data de Fim de Listagem de Operações</b></label>
                <bn-datepicker idInput="dataFimListagemOperacoes" formControlName="dataFimListagemOperacoes" ></bn-datepicker>
            </div>

            <div class="bn-form-group col-md-6">
                <label class="form-label"><b>Data da Última Execução</b></label>
                <bn-datepicker idInput="dataUltimaExecucao" formControlName="dataUltimaExecucao" ></bn-datepicker>
            </div>

            <div class="bn-form-group col-md-3">
                <label class="form-label"><b>Processamento Habilitado</b></label>
                <input type="checkbox" class="form-check checkbox-gigante" idInput="processamentoHabilitado" formControlName="processamentoHabilitado" />
            </div>

            <div class="bn-form-group col-md-3">
                <label class="form-label"><b>Execução realizada com sucesso</b></label>
                <input type="checkbox" class="form-check checkbox-gigante" idInput="ultimaExecucaoRealizadaComSucesso" formControlName="ultimaExecucaoRealizadaComSucesso" />
            </div>

        </div>

    </form>    
</div>

<div class="container" *ngIf="ocorrencias?.length > 0">
    <div class="row">
        <div class="table-responsive col-auto">
            <table class="table-striped table-bordered">
                <thead>
                    <tr>
                        <th class="text-center">Erro(s) encontrado(s)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let ocorrencia of ocorrencias">
                        <td>{{ ocorrencia.mensagem }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>    
</div>
